import {
	easterEggsLoading,
	easterEggsSuccess,
	easterEggFailure,
	userEasterEggsLoading,
	userEasterEggsLoadingSuccess,
	userEasterEggsLoadingFailure,
	postEasterEggFoundSuccess,
	postEasterEggFoundFailure,
	getAmIMasterEggHunterSuccess,
	getAmIMasterEggHunterFailure,
	masterEggHuntersLoading,
	getMasterEggHuntersSuccess,
	getMasterEggHuntersFailure,
} from 'redux/actions';
import * as requests from 'api/requests';
import { addSuccessToast, addErrorToast } from 'components/Toast/toastService';

export function getEasterEggsForUser(userId: string) {
	return (dispatch: any) => {
		dispatch(userEasterEggsLoading());

		return requests
			.getEasterEggsForUser(userId)
			.then(data => {
				dispatch(userEasterEggsLoadingSuccess(data));
			})
			.catch(error => {
				dispatch(userEasterEggsLoadingFailure(error));
			});
	};
}

export function getEasterEggs() {
	return (dispatch: any) => {
		dispatch(easterEggsLoading());

		return requests
			.getEasterEggs()
			.then(data => {
				dispatch(easterEggsSuccess(data));
			})
			.catch(error => {
				dispatch(easterEggFailure(error));
			});
	};
}

export function postEasterEggFound(eggId: string) {
	return (dispatch: any) => {
		return requests
			.postEasterEggFound(eggId)
			.then(data => {
				dispatch(postEasterEggFoundSuccess(data));
				dispatch(getAmIMasterEggHunter());
				addSuccessToast(dispatch, 'You have found an easter egg 🤩');
			})
			.catch(error => {
				dispatch(postEasterEggFoundFailure(error));
			});
	};
}

export function getAmIMasterEggHunter() {
	return (dispatch: any) => {
		return requests
			.getAmIMasterEggHunter()
			.then(data => {
				dispatch(getAmIMasterEggHunterSuccess(data));
			})
			.catch(error => {
				dispatch(getAmIMasterEggHunterFailure(error));
			});
	};
}

export function getMasterEggHunters() {
	return (dispatch: any) => {
		dispatch(masterEggHuntersLoading());
		return requests
			.getMasterEggHunters()
			.then(data => {
				dispatch(getMasterEggHuntersSuccess(data));
			})
			.catch(error => {
				dispatch(getMasterEggHuntersFailure(error));
				addErrorToast(dispatch, 'Oh no! An error occured while retrieving the list of master egg hunters.');
			});
	};
}
